import React, { useEffect } from "react";
import { Outlet, useLocation, Navigate } from "react-router-dom";
import classNames from "classnames";
import NavbarTopOsiris from "components/navbar/top/NavbarTopOsiris";
import NavbarVerticalOsiris from "components/navbar/vertical/NavbarVerticalOsiris";
import Footer from "components/footer/Footer";
import { useAppContext } from "providers/AppProvider";
import ProtectedRoute from "components/common/pyramid/ProtectedRoute";
import useTheme, { useDevExtremeTheme } from "providers/ThemeProvider";
import { useThemeContext } from "providers/ThemeProvider";
import { useAuth } from "hooks/useAuth";
import paths from "routes/paths";

const OsirisLayout = () => {
  const { hash, pathname } = useLocation();
  const isKanban = pathname.includes("kanban");
  const { config } = useAppContext();
  const { setCurrentModule } = useThemeContext();
  const { hasModule, isLoading } = useAuth();

  useEffect(() => {
    setTimeout(() => {
      if (hash) {
        const id = hash.replace("#", "");
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "start", behavior: "smooth" });
        }
      }
    }, 0);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Switching currentModule for components requiring further context
  useEffect(() => {
    setCurrentModule("osiris");
  }, [setCurrentModule]);

  // Switching Bootstrap and DevExtreme themes
  useTheme("osiris");
  useDevExtremeTheme("osiris", config.isDark ? "dark" : "light");

  // Checking if the user has access to Osiris
  if (!isLoading && !hasModule("Osiris")) {
    return <Navigate to={paths.solutionsShowcase} replace />;
  }

  return (
    <ProtectedRoute>
      <div className="container">
        <NavbarVerticalOsiris />
        <div className={classNames("content", { "pb-0": isKanban })}>
          <NavbarTopOsiris />
          {/*------ Main Routes ------*/}
          <Outlet />
          {!isKanban && <Footer />}
        </div>
      </div>
    </ProtectedRoute>
  );
};

export default OsirisLayout;
